import React, { useState, useEffect } from 'react';
import { Form, Button } from '@blueprintnyc/bpnyc-common';
import { Toggle } from '@blueprintnyc/bpnyc-common-admin';
import OmniPicker from '@/components/OmniPicker';
import IconItemOptions from './IconItemOptions';
import EventGroupsPicker from '@/components/EventGroupsPicker';

const IconWidgetOptions = props => {
	const {
		event,
		widgetToUpdate,
		widgetProps,
		onUpdate,
		setOmniPicker,
		omniPicker,
		handlePickMedia,
		handleChange,
		setWidgetToUpdate,
		handleGroupChange,
		targetKeys,
	} = props;
	const { amount = '1' } = widgetProps;
	const [iconProps, setIconProps] = useState([]);
	const iconArr = new Array(Number(amount)).fill('');

	useEffect(() => {
		setIconProps(widgetProps.icons);
	}, [widgetProps]);

	useEffect(() => {
		if (widgetProps.icons && amount !== widgetToUpdate.props.amount) {
			const updatedIconArr = widgetProps.icons.slice(0, amount);
			setWidgetToUpdate({
				...widgetToUpdate,
				props: { ...widgetProps, icons: updatedIconArr },
				toUpdate: true,
			});
			setIconProps(updatedIconArr);
		}
	}, [amount]);

	const handleSetIconProps = (key, index, value) => {
		let arr = [...iconProps];
		if (arr[index]) arr[index][key] = value;
		else arr = [...iconProps, { ...iconProps[index], [key]: value }];
		setIconProps(arr);
		handleChange({ ...widgetProps, icons: arr });
	};

	const handlePickOmniItem = (pickedLink, index) => {
		handleSetIconProps('onPress', index, pickedLink);
		setOmniPicker({ open: false, mediaPicker: false, from: '', index: null });
	};

	return (
		<Form initialValues={widgetToUpdate.props} onChange={handleChange}>
			<div className="WidgetUpdateForm">
				<Form.Item label="Number of Icons in Row" name="amount">
					<Toggle toggleOptions={['1', '2', '3', '4']} />
				</Form.Item>
				<Form.Item label="Icon Size" name="size">
					<Toggle toggleOptions={['small', 'large', 'full']} />
				</Form.Item>
				{widgetProps.size !== 'full' ? (
					<Form.Item label="Icon Alignment" name="alignment">
						<Toggle toggleOptions={['left', 'center', 'right', 'spaced']} />
					</Form.Item>
				) : null}
				{iconArr &&
					iconArr.map((_, index) => (
						<IconItemOptions
							{...props}
							iconProps={iconProps}
							index={index}
							handleSetIconProps={handleSetIconProps}
							handlePickOmniItem={handlePickOmniItem}
							key={`icon-item-option-${index}`}
						/>
					))}
				<h4 className="admin-form-item-label">Group Permissions</h4>
				<div className="groups-picker">
					<EventGroupsPicker
						event={event}
						handleChange={handleGroupChange}
						targetKeys={targetKeys}
					/>
				</div>
			</div>
			<Button type="submit" style={{ marginTop: '15px' }} onClick={() => onUpdate(widgetProps)}>
				Submit
			</Button>
			<OmniPicker
				event={event}
				visible={omniPicker.open}
				onCancel={() => setOmniPicker({ open: false, mediaPicker: false, from: '', onPress: {} })}
				handlePickItem={pickedLink => handlePickOmniItem(pickedLink, omniPicker.index)}
				handlePickMedia={handlePickMedia}
				mediaPicker={omniPicker.mediaPicker}
				onPress={omniPicker.onPress}
				from={omniPicker.from}
			/>
		</Form>
	);
};

export default IconWidgetOptions;
